export function stored(key, session = false) {
	try {
		return (session ? sessionStorage : localStorage).getItem(key);
	} catch {
		return null;
	}
}
export function store(key, value, session = false) {
	try {
		(session ? sessionStorage : localStorage).setItem(key, String(value));
	} catch {}
}
export function rulesFor(slide) {
	try {
		return JSON.parse(slide.dataset.popupRules || "{}");
	} catch {
		return {};
	}
}
export function matchesRules(rules, context = {}) {
	const device = innerWidth <= 600 ? "mobile" : innerWidth <= 1024 ? "tablet" : "desktop";
	if (rules.devices && !rules.devices.includes(device)) return false;
	if (rules.hide_logged_in && context.logged_in) return false;
	if (rules.country) {
		const country = (context.country || "").toLowerCase();
		let name = country;
		try {
			if (country.length === 2)
				name = new Intl.DisplayNames(["en"], { type: "region" })
					.of(country.toUpperCase())
					.toLowerCase();
		} catch {}
		if (![country, name].includes(rules.country.toLowerCase())) return false;
	}
	const visitKey = "solufy_popup_visitor_session";
	let isNew = stored(visitKey, true);
	if (isNew === null) {
		isNew = stored("solufy_popup_visited") ? "returning" : "new";
		store(visitKey, isNew, true);
		store("solufy_popup_visited", 1);
	}
	if (rules.audience && rules.audience !== "all" && rules.audience !== isNew) return false;
	if (rules.source) {
		let source = new URLSearchParams(location.search).get("utm_source");
		if (!source) {
			try {
				source = JSON.parse(stored("solufy_attribution") || "{}").utm_source;
			} catch {}
		}
		if (!source) {
			try {
				source =
					document.referrer && new URL(document.referrer).origin !== location.origin
						? new URL(document.referrer).hostname
						: "Direct";
			} catch {
				source = "Direct";
			}
		}
		if (!source.toLowerCase().includes(rules.source.toLowerCase())) return false;
	}
	if (rules.schedule) {
		const now = new Date();
		if (rules.start_at && now < new Date(rules.start_at)) return false;
		if (rules.end_at && now > new Date(rules.end_at)) return false;
		if (rules.days && !rules.days.includes(now.getDay())) return false;
	}
	return true;
}
export function frequencyAllows(slide, rules) {
	const key = "solufy_popup_seen_" + slide.dataset.bannerName;
	if (rules.frequency === "once" && stored(key)) return false;
	if (rules.frequency === "session" && stored(key, true)) return false;
	return !(rules.hide_converted && stored("solufy_popup_converted_" + slide.dataset.bannerName));
}
export function rememberSlide(slide) {
	const key = "solufy_popup_seen_" + slide.dataset.bannerName;
	store(key, 1);
	store(key, 1, true);
}
export function presentation(popup, slide) {
	const rules = rulesFor(slide);
	popup.dataset.popupType = rules.popup_type || "modal";
	popup.dataset.position = rules.position || "center";
	popup.dataset.animation = rules.animation || "scale";
	popup.dataset.closePosition = rules.close_position || "top-right";
	const close = popup.querySelector("[data-popup-close]");
	close.hidden = rules.close_button === false;
	popup.style.borderRadius = (rules.radius ?? 16) + "px";
	popup.style.boxShadow = {
		none: "none",
		soft: "0 8px 24px #152b4b20",
		strong: "0 24px 70px #152b4b40",
	}[rules.shadow || "strong"];
}
export function armTrigger(rules, callback, defaultDelay, signal) {
	const trigger = rules.trigger || "default";
	if (["default", "load", "delay"].includes(trigger)) {
		const timer = setTimeout(
			callback,
			trigger === "load"
				? 0
				: trigger === "delay"
				? Number(rules.delay || 0) * 1000
				: defaultDelay
		);
		signal.addEventListener("abort", () => clearTimeout(timer));
		return;
	}
	if (trigger === "scroll") {
		const check = () => {
			const height = document.documentElement.scrollHeight - innerHeight;
			if (
				(height <= 0 ? 100 : (scrollY / height) * 100) >=
				Number(rules.scroll_percent ?? 50)
			) {
				window.removeEventListener("scroll", check);
				callback();
			}
		};
		window.addEventListener("scroll", check, { passive: true, signal });
		check();
	}
	if (trigger === "exit")
		document.addEventListener(
			"mouseout",
			(event) => {
				if (!event.relatedTarget && event.clientY <= 5) callback();
			},
			{ signal }
		);
	if (trigger === "click")
		document.addEventListener(
			"click",
			(event) => {
				try {
					if (rules.click_selector && event.target.closest(rules.click_selector))
						callback();
				} catch {}
			},
			{ signal }
		);
}
export async function targetingContext(slides) {
	if (
		!slides.some((slide) => {
			const rules = rulesFor(slide);
			return rules.country || rules.hide_logged_in;
		})
	)
		return {};
	try {
		const response = await fetch(
			"/api/method/solufy_website.services.popup_submissions.targeting_context"
		);
		return (await response.json()).message || {};
	} catch {
		return {};
	}
}
